<template>
  <div>
    <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" router>
      <template v-for="(item, index) in asideList">
        <el-submenu :index="item.url || String(index)" :key="'sub_' + index" v-if="hasChildren(item)">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>{{ item.name }}</span>
          </template>
          <template v-for="(son, i) in item.children">
            <el-menu-item :index="son.url" :key="'item_' + index + '_' + i" v-if="!hasChildren(son)">{{ son.name }}</el-menu-item>
            <el-submenu :index="son.url || String(index) + '_' + String(i)" :key="'sub_' + index + '_' + i" v-if="hasChildren(son)">
              <template slot="title">{{ son.name }}</template>
              <el-menu-item :index="grandson.url" v-for="(grandson, ii) in son.children" :key="'item_' + index + '_' + i + '_' + ii">{{ grandson.name }}</el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>

        <el-menu-item :index="item.url" :key="'top_' + index" v-if="!hasChildren(item)">
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'Aside',
    created() {
      this.getAsideList();
    },
    data() {
      return {
        asideList: []
      };
    },
    methods: {
      hasChildren(item) {
        if (!item) {
          return false;
        }
        if (!item.children) {
          return false;
        }
        return item.children.length > 0;
      },
      getAsideList() {
        this.axios
          .get('/common/aside/getAsideList')
          .then(res => {
            if (res.data.code == 0) {
              this.asideList = res.data.data || [];
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(function(error) {
            this.$message.error('请求失败');
          });
      },
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/aside.vue